import type { JSX, ReactNode } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@mailflare/ui";

export interface AuthCardProps {
  readonly title: string;
  readonly description: string;
  readonly children: ReactNode;
  readonly footer?: ReactNode;
}

/** Centered card used by the sign-in, sign-up, and MFA screens. */
export function AuthCard({ title, description, children, footer }: AuthCardProps): JSX.Element {
  return (
    <main className="bg-muted/40 flex min-h-dvh items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <p className="mb-1 flex items-center gap-2 text-lg font-semibold tracking-tight">
            <span className="bg-primary text-primary-foreground flex size-7 items-center justify-center rounded-md text-sm font-bold">
              M
            </span>
            MailFlare
          </p>
          <CardTitle className="text-xl">{title}</CardTitle>
          <CardDescription>{description}</CardDescription>
        </CardHeader>
        <CardContent>
          {children}
          {footer !== undefined ? <div className="mt-5 text-sm">{footer}</div> : null}
        </CardContent>
      </Card>
    </main>
  );
}

/** Extracts a safe, user-facing message from an unknown mutation error. */
export function errorText(error: unknown): string {
  if (error instanceof Error) return error.message;
  return "Something went wrong. Please try again.";
}
